import * as React from 'react';

export const Help: React.FC = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.06693 14.6667C7.26693 14.6667 6.73359 14.1333 6.73359 13.3333C6.73359 12.5333 7.26693 12 8.06693 12C8.86693 12 9.40026 12.5333 9.40026 13.3333C9.40026 14.1333 8.86693 14.6667 8.06693 14.6667ZM10.0669 8.53334C9.40026 8.93334 9.40026 9.06668 9.40026 9.33334V10.6667H6.73359V9.33334C6.73359 7.60001 7.80026 6.80001 8.60026 6.26668C9.26693 5.86668 9.40026 5.73334 9.40026 5.33334C9.40026 4.53334 8.86693 4.00001 8.06693 4.00001C7.53359 4.00001 7.13359 4.26668 6.86693 4.66668L6.20026 5.86668L3.93359 4.53334L4.60026 3.33334C5.26693 2.13334 6.60026 1.33334 8.06693 1.33334C10.3336 1.33334 12.0669 3.06668 12.0669 5.33334C12.0669 7.20001 10.8669 8.00001 10.0669 8.53334Z"
        fill="#006CFD"
      />
    </svg>
  );
};

Help.displayName = 'Help';
